export default __webpack_public_path__ + "static/media/Gol.505573ce.png";